import axios from 'axios';

export default class Client {

    constructor(config = {}) {
        this.protocol = config.protocol || 'https';
        this.host = config.host;
        this.version = config.version || 'v1';
        this.tenant = config.tenant;

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.timeout = 30000;
    }

    url(path = '') {
        if (this.tenant) {
            return `${this.protocol}://${this.tenant}.${this.host}/api/${this.version}/${path}`;
        }
        return `${this.protocol}://${this.host}/api/${this.version}/${path}`;
    }

    get(url, config = {}) {
        return axios.get(url, config)
            .then(response => ({ response }))
            .catch(error => ({ error }));
    }

    post(url, data, config = {}) {
        return axios.post(url, data, config)
            .then(response => ({ response }))
            .catch(error => ({ error }));
    }

    register(namespace, resource) {
        if (!this[namespace]) {
            this[namespace] = {};
        }
        this[namespace] = Object.keys(resource).reduce((result, endpoint) => {
            result[endpoint] = (...args) => resource[endpoint](this, ...args);
            return result;
        }, {});
        return this;
    }
}
